import React, { useState, useEffect } from "react";
import Loader from "../../components/Loader";
import axiosInstance from "../../utils/api";
// import { Form, Button, Col } from "react-bootstrap";
// import "antd/dist/antd.css";
// import { message, notification } from "antd";

type Props = {}

const Node = (props: Props) => {
    //fetch api http://api.cl-ds.com/adminGetNodeSelection/
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<any>();
    const [values, setvalues] = useState<any>({
        database: [],
        datatable: [],
        mqtt: [],
        project: [],
        t_bot: [],
        t_channel: [],
        serial: [],
        device: [],
        sensor_set: [],
        product: [],
        premise: [],
        tag_name: [],
        multi_set: [],
        remote: [],
        location_lat: 5.32274177,
        location_long: 100.278917,
        location_name: "Sunway Tunas, Penang",
        location_add: "50-1, Persiaran Mahsuri 2",
        number_user: 0,
    });

    //Fetch Data From API to fill the needed form
    useEffect(() => {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/adminGetNodeSelection/").then((fetchdata) => {
            setLoading(false)
            setData(fetchdata);
            setvalues({
                ...values,
                database: values.database,
                datatable: values.datatable,
                mqtt: values.mqtt,
                project: values.project,
                t_bot: values.t_bot,
                t_channel: values.t_channel,
            });
            console.log(fetchdata);
        }).catch(err=>{
            setLoading(false)
            console.log(err)
        })
    }, []);

    //Showing result in the view data button
    const openResult = () => {

        alert("Button was clicked")
        // notification.open({
        // message: "Form Data",
        // duration: 0,
        // description: JSON.stringify(values),
        // onClick: () => {
        //     console.log("Button was clicked");
        // },
        // });
    };

    //Exports data into a json file (downloads the data)
    function exportToJsonFile() {
        let dataStr = JSON.stringify(values);
        let dataUri = "data:dataInput/json;charset=utf-8," + encodeURIComponent(dataStr);

        let exportFileDefaultName = "config.json";

        let linkElement = document.createElement("a");
        linkElement.setAttribute("href", dataUri);
        linkElement.setAttribute("download", exportFileDefaultName);
        linkElement.click();
        console.log(values);
    }

    //Checks for change in values
    const onCheckhandler = () => {
        setvalues({
        ...values,
        remote: !values.remote,
        multi_set: !values.multi_set,
        });
    };

    const onChangehandler = (e:React.ChangeEvent<HTMLInputElement>) => {
        setvalues({
        ...values,
        [e.target.name]: e.target.value,
        });
    };

    
    const onChangeSelecthandler = (e:React.ChangeEvent<HTMLSelectElement>) => {
        setvalues({
        ...values,
        [e.target.name]: e.target.value,
        });
    };

    //Uploads data from config and displays into the form
    const handleChange = (e:any) => {
        const fileReader = new FileReader();
        fileReader.readAsText(e.target.files[0], "UTF-8");
        fileReader.onload = (e) => {
        // console.log("e.target.result", e.target.result);
        setvalues(JSON.parse(e.target?.result as any));
        console.log(values);
        }
    };

    //After Submit
    const onSubmitHandler = (e:React.FormEvent<HTMLFormElement>) => {
        console.log(values);
        e.preventDefault();
        const form = e.currentTarget;

        //Post request
        const sendPost = {
        method: "POST",
        headers: {
            Authorization: " Token 62990ac3b609e5601a678c1e133416e6da7f10db ",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
        };
        //Display message
        axiosInstance.get("https://api.cl-ds.com/kaviTest/", values).then((response) => {
            if (response.status === 200) {
                return response;
            }
        });
        // .then((data) => {
        //   console.log(data.message);
        //   message.success(data.message);
        // });

        //validation checked
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            alert("Form is not filled!")
        } else if (form.checkValidity() === true) {
            alert("Form Filled!")
        }
    };

    return (
        <>
        <div className="col-lg-8 mx-auto">
            
            {loading && ( <Loader/> )}

            <header>
            <h2 className="text-center"> Dashboard </h2>
            </header>

            
              <form className="row g-3" onSubmit={onSubmitHandler}>
                <div className="col-md-6">
                    <input
                    style={{ float: "right" }}
                    type="file"
                    onChange={handleChange}/>
                </div>
                <div className="col-md-6">
                    <button
                    style={{ float: "right" }}
                    className="btn btn-primary"
                    type="button"
                    onClick={exportToJsonFile}
                    >
                    Download config
                    </button>
                </div>
                <div className="col-md-4">
                    <label className="form-label">Serial</label>
                    <input
                        className="form-control"
                        type="text"
                        name="serial"
                        value={values.serial}
                        placeholder="serial"
                        onChange={onChangehandler}
                        required
                    />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Device</label>
                    <input
                        className="form-control"
                        type="text"
                        name="device"
                        value={values.device}
                        placeholder="device"
                        onChange={onChangehandler}
                        required
                    />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Tag_name</label>
                    <input
                        className="form-control"
                        type="text"
                        name="tag_name"
                        placeholder="Tag_name"
                        onChange={onChangehandler}
                        value={values.tag_name}
                    />
                </div>
                <div className="col-12">
                  <label className="form-label">Database</label>
                    <select
                        name="database"
                        className="form-select"
                        onChange={(e) => onChangeSelecthandler(e)}>
                        <option value="none" selected disabled hidden>
                        Select an Option
                        </option>
                        {!!data?.database?.length &&
                        data.database.map((item:any) => (
                            <option key={item} value={item}>
                            {item}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-12">
                  <label className="form-label">MQTT</label>
                    <select
                        name="mqtt"
                        className="form-select"
                        onChange={(e) => onChangeSelecthandler(e)} >
                        <option value="none" selected disabled hidden>
                        Select an Option
                        </option>
                        {!!data?.mqtt?.length &&
                        data.mqtt.map((item:any) => (
                            <option key={item} value={item}>
                            {item}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-6">
                  <label className="form-label">Project</label>
                    <select
                        name="project"
                        className="form-select"
                        onChange={(e) => onChangeSelecthandler(e)}>
                        <option value="none" selected disabled hidden>
                        Select an Option
                        </option>
                        {!!data?.project?.length &&
                        data.project.map((item:any) => (
                            <option key={item} value={item}>
                            {item}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-6">
                  <label className="form-label">Datatable</label>
                    <select
                        name="datatable"
                        className="form-select"
                        onChange={(e) => onChangeSelecthandler(e)}>
                        <option value="none" selected disabled hidden>
                        Select an Option
                        </option>
                        {!!data?.datatable?.length &&
                        data.datatable.map((item:any) => (
                            <option key={item} value={item}>
                            {item}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-4">
                  <label className="form-label">T_Bot</label>
                    <select
                        name="t_bot"
                        className="form-select"
                        onChange={(e) => onChangeSelecthandler(e)}>
                        <option value="none" selected disabled hidden>
                        Select an Option
                        </option>
                        {!!data?.t_bot?.length &&
                        data.t_bot.map((item:any) => (
                            <option key={item} value={item}>
                            {item}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-4">
                  <label className="form-label">T_Channel</label>
                    <select
                        name="t_channel"
                        className="form-select"
                        onChange={(e) => onChangeSelecthandler(e)}>
                        <option value="none" selected disabled hidden>
                        Select an Option
                        </option>
                        {!!data?.t_channel?.length &&
                        data.t_channel.map((item:any, i:any) => (
                            <option key={item + i} value={item}>
                            {item}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-4">
                  <label className="form-label">Sensor_Set</label>
                    <input
                        className="form-control"
                        type="number"
                        name="sensor_set"
                        value={values.sensor_set}
                        placeholder="sensor_set"
                        onChange={onChangehandler}
                        required
                    />
                </div>
                <div className="col-6">
                    <label className="form-label">Location_Lat</label>
                    <input
                        className="form-control"
                        type="number"
                        name="location_lat"
                        value={values.location_lat}
                        onChange={onChangehandler}
                    />
                </div>
                <div className="col-6">
                    <label className="form-label">Location_Long</label>
                    <input
                        className="form-control"
                        type="number"
                        name="location_long"
                        value={values.location_long}
                        onChange={onChangehandler}
                    />
                </div>
                <div className="col-6">
                    <label className="form-label">Location_Name</label>
                    <input
                        className="form-control"
                        type="text"
                        name="location_name"
                        value={values.location_name}
                        onChange={onChangehandler}
                    />
                </div>
                <div className="col-6">
                    <label className="form-label">Location_Add</label>
                    <input
                        className="form-control"
                        type="text"
                        name="location_add"
                        value={values.location_add}
                        onChange={onChangehandler}
                    />
                </div>

                <div className="col-6">
                    <label className="form-label">Number_User</label>
                    <input
                        className="form-control"
                        type="number"
                        name="number_user"
                        value={values.number_user}
                        onChange={onChangehandler}
                    />
                </div>
                <div className="col-6">
                    <label className="form-label">Product</label>
                    <input
                        className="form-control"
                        type="text"
                        name="product"
                        value={values.product}
                        placeholder="product.."
                        onChange={onChangehandler}
                        required
                    />
                </div>
                <div className="col-12">
                    <label className="form-label">Premise</label>
                    <input
                        className="form-control"
                        type="text"
                        name="premise"
                        value={values.premise}
                        placeholder="premise"
                        onChange={onChangehandler}
                        required
                    />
                </div>

                <div className="col-6">
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox"
                        value={values.multi_set}
                        onChange={onCheckhandler}/>
                        <label className="form-check-label" >
                            Multi_Set
                        </label>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-check">
                        <input className="form-check-input" 
                            value={values.remote}
                            type="checkbox"
                            onChange={onCheckhandler}/>
                        <label className="form-check-label" >
                            Remote
                        </label>
                    </div>
                </div>


                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Submit</button>
                </div>

              </form>


                <button type="button" className="btn btn-primary" onClick={openResult}>
                    View Data
                </button>


        </div>
        </>
    )
}

export default Node